
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacypolicy/20200807",
      function () {
        return require("private-next-pages/privacypolicy/20200807/index.js");
      }
    ]);
  